import { create } from "zustand"

type ProductManagementStore = {
  selectedProductIds: number[]
  refreshProductList?: () => void
  actions: {
    setRefreshProductList: (func: () => void) => void
    setSelectedRowKeys: (rowKeys: number[]) => void
  }
}

const useProductManagementStore = create<ProductManagementStore>((set) => ({
  selectedProductIds: [],
  actions: {
    setRefreshProductList: (func: () => void) => {
      set({ refreshProductList: func })
    },
    setSelectedRowKeys: (rowKeys: number[]) => {
      set({ selectedProductIds: rowKeys })
    },
  },
}))

export { useProductManagementStore }
